var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smartScreen"},[_c('div',{staticClass:"the-banner"}),_c('div',{staticClass:"bgbox-white"})])}]

export { render, staticRenderFns }